import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const Preferences = () => {
  const { currentTheme, changeTheme, themes } = useTheme();

  return (
    <div className="max-w-4xl">
      <div className="space-y-6">
        <div className="bg-theme-main rounded-lg border border-theme-secondary p-6">
          <h2 className="text-lg font-semibold text-theme-text mb-1">Theme</h2>
          <p className="text-sm text-theme-text opacity-80 mb-6">
            Choose a color theme for your dashboard
          </p>

          <p className="text-xs text-theme-text opacity-60 mb-3 sm:hidden">
            Swipe to see more themes
          </p>

          <div className="flex gap-3 overflow-x-auto pb-2 pr-6 sm:pr-0 sm:pb-0 sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-4 snap-x snap-mandatory">
            {Object.entries(themes).map(([key, themeOption]) => (
              <button
                key={key}
                type="button"
                onClick={() => changeTheme(key)}
                className={`relative p-4 rounded-lg border-2 transition-all text-left flex-shrink-0 w-[85%] sm:w-auto snap-start ${
                  currentTheme === key
                    ? "border-theme-primary"
                    : "border-theme-secondary hover:border-theme-primary hover:border-opacity-50"
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium text-theme-text">{themeOption.name}</span>
                  {currentTheme === key && (
                    <svg
                      className="h-5 w-5 text-theme-primary"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </div>
                <p className="text-xs text-theme-text opacity-80 mb-3">
                  {themeOption.description}
                </p>
                <div className="flex gap-1">
                  <div
                    className="flex-1 h-8 rounded"
                    style={{ backgroundColor: themeOption.secondaryBackground }}
                  />
                  <div
                    className="flex-1 h-8 rounded"
                    style={{ backgroundColor: themeOption.textColor }}
                  />
                  <div
                    className="flex-1 h-8 rounded"
                    style={{ backgroundColor: themeOption.primaryActionColor }}
                  />
                  <div
                    className="flex-1 h-8 rounded"
                    style={{ backgroundColor: themeOption.secondaryActionColor }}
                  />
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
